"use client";

import React from "react";
import { Button, ButtonProps } from "@chakra-ui/react";

interface AppButtonProps extends ButtonProps {
  label: React.ReactNode;
}

const AppButton: React.FC<AppButtonProps> = ({ label, ...props }) => {
  return (
    <Button
      color="white"
      backgroundColor="#1746A2"
      _hover={{ bg: "blue.400", color: "white" }}
      {...props}
    >
      {label}
    </Button>
  );
};

export default AppButton;
